import React, { Component } from 'react';
import {Spin, message} from 'antd';
import * as XLSX from 'xlsx'; 
import FileSaver from 'file-saver'; 
// import echarts from 'echarts';

// import line_icon from '../../../images/line.svg'
// import s_line_icon from '../../../images/s-line.svg'
// import bar_icon from '../../../images/bar.svg'
// import s_bar_icon from '../../../images/s-bar.svg'
// import pie_icon from '../../../images/pie.svg'
// import s_pie_icon from '../../../images/s-pie.svg'
// import radar_icon from '../../../images/radar.svg'
// import s_radar_icon from '../../../images/s-radar.svg'

export default class GroupCharts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            axisStyle: false,
            mark: false,
            loading: false,
            dataSource:[],
        }
    }

    componentDidMount() {
        this.chart = echarts.init(this.refs.chart);
        let dataSource =  this.props.dataSource;
        let service = this.props.service;
        let keywords = this.props.keywords;
        if(dataSource) {
            this.initCharts(dataSource);
        } else if(service){
            if(keywords.v != this.state.v && this.state.v) {
                this.setState({
                    loading: true
                })
                service.queryCharts(keywords).then(data => {
                    if(data) {
                        this.setState((prevState, state) => {
                            return {
                                max: data.max,
                                min: data.min,
                                dataSource: data.dataSource
                            }
                        });
                        this.initCharts(data.dataSource);
                    }
                    this.setState({
                        loading: false
                    })
                })
            }
            this.setState({
                v: keywords.v
            })
        }
    }

    changeChart(chartName) {
        this.props.changeChart(chartName)
    }

    changeStyle(){
        this.setState({
            axisStyle: !this.state.axisStyle,
            v: this.props.keywords?this.props.keywords.v:Date.now()
        });
    }

    componentWillReceiveProps(nextProps) {
        this.chart = echarts.init(this.refs.chart);
        let dataSource =  nextProps.dataSource;
        let service = nextProps.service;
        let keywords = nextProps.keywords;
        this.props = nextProps;

        if(dataSource) {
            this.initCharts(dataSource);
        } else if(service){
            if(keywords.v != this.state.v && this.state.v) {
                this.setState({
                    loading: true
                })
                service.queryCharts(keywords).then(data => {
                    if(data) {
                        this.setState((prevState, state) => {
                            return {
                                max: data.max,
                                min: data.min,
                                dataSource: data.dataSource
                            }
                        });
                        this.initCharts(data.dataSource);
                    }
                    this.setState({
                        loading: false
                    })
                })
            }
            this.setState({
                v: keywords.v
            })
        }
    }

    getDataSource() {
        let dataSource = this.props.dataSource;
        if(dataSource) {
            return dataSource;
        } else {
            return this.state.dataSource;
        }
    }

    getMax(max) {
        if(this.state.max) {
            return this.state.max
        }
        if(this.props.max) {
            return this.props.max
        }

        return max
    }

    getMin(min) {
        if(this.state.min) {
            return this.state.min
        }
        if(this.props.min) {
            return this.props.min
        }
        return min
    }

    initCharts(dataSource) {
        let initChartsType = this.props.initChartsType;
        if(initChartsType || this.initChartsType) {
            if(this.initChartsType) {
                initChartsType = this.initChartsType
            } else {
                this.initChartsType = initChartsType
            }
            if(initChartsType === 'line') {
                this.setLineChart(dataSource);
            } else if(initChartsType === 'bar') {
                this.setBarChart(dataSource);
            } else if(initChartsType === 'pie') {
                this.setPieChart(dataSource);
            } else if(initChartsType === 'radar') {
                this.setRadarChart(dataSource);
            }
        } else {
            this.setLineChart(dataSource);
        }
    }

    setLineChart(dataSource) {
        if(dataSource.length === 0) {
            return
        }
        this.initChartsType = 'line'
        const dataLength = Array.from(new Set(dataSource.map(d => d.category))).length
        const axisStyle = this.state.axisStyle;
        dataSource  = dataSource.map(item => {
            return {
                name: item.category,
                count: +item.value,
                value: item.value,
                series: item.series || '数据',
                percentage: item.percentage
            }
        });
        const values = (dataSource || []).map(item => +item.value);
        // 求最大值和最小值
        const valuesMax = values.reduce((a, b) => a > b ? a : b );
        const valuesMin = values.reduce((a, b) => a < b ? a : b);
        // 偏移量
        const d = (valuesMax - valuesMin) * 0.1;
        const max = valuesMax + d
        const min = (valuesMin - d) <= 0 ? 0 : (valuesMin - d);
        let axisLabel = this.props.axisLabel;
        let option = {
            title : this.props.title ? this.props.title : {
                text: `数据分析`,
                subtext: ``,
                x: 'center'
            },
            tooltip : {
                trigger: 'axis',
            },
            grid: {
                left: '3%',
                right: '10%',
                bottom: '3%',
                containLabel: true
            },
            toolbox: {
                show : true,
                feature : {
                    markUndo : {show: true},
                    markClear : {show: true},
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    saveAsImage : {show: true},
                    myTool16: {
                        show: true,
                        title: '数据导出',
                        icon: 'image://../images/excel.svg',
                        onclick: () => {
                            const exportConfig = this.props.exportConfig;
                            if (exportConfig) {
                                let data = exportConfig.data;
                                const dataCb = exportConfig.dataCb;
                                if (dataCb) {
                                    data = dataCb(this.getDataSource());
                                }
                                const worksheet = XLSX.utils.json_to_sheet(data);
                                const workbook = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1'); 
                                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }); 
                                const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                                FileSaver.saveAs(excelBlob, `${exportConfig.title || '数据导出'}.xlsx`);
                            } else {
                                message.warn('暂不支持');
                            }
                        }
                    },
                    myTool17: {
                        show: true,
                        title: '数据升序',
                        icon: 'image://../images/asc.svg',
                        onclick: () => {
                            const d = this.getDataSource().map(e => e);
                            d.sort((e1, e2) => {
                                if (e1.value === null && e2.value === undefined) {
                                    return 0;
                                }
                                if (e1.value === null || e2.value === undefined) {
                                    return -1;
                                }
                                return e1.value - e2.value;
                            })
                            this.setLineChart(d);
                        }
                    },
                    myTool18: {
                        show: true,
                        title: '数据降序',
                        icon: 'image://../images/desc.svg',
                        onclick: () => {
                            const d = this.getDataSource().map(e => e);
                            d.sort((e1, e2) => {
                                if (e1.value === null && e2.value === undefined) {
                                    return 0;
                                }
                                if (e1.value === null || e2.value === undefined) {
                                    return -1;
                                }
                                return e2.value - e1.value;
                            })
                            this.setLineChart(d);
                        }
                    },
                    myTool11: {
                        show: true,
                        title: '折线图',
                        icon: 'image://../images/s-line.svg',
                        // icon: 'image://' + s_line_icon,
                        onclick: () => {
                            this.setLineChart(this.getDataSource());
                        }
                    },
                    myTool12: {
                        show: true,
                        title: '柱状线',
                        icon: 'image://../images/bar.svg',
                        // icon: 'image://' + bar_icon,
                        onclick: () => {
                            this.setBarChart(this.getDataSource());
                        }
                    },
                    myTool13: {
                        show: true,
                        title: '饼图',
                        icon: 'image://../images/pie.svg',
                        // icon: 'image://' + pie_icon,
                        onclick: () => {
                            this.setPieChart(this.getDataSource());
                        }
                    },
                    myTool14: {
                        show: true,
                        title: '雷达图',
                        icon: 'image://../images/radar.svg',
                        // icon: 'image://' + radar_icon,
                        onclick: () => {
                            this.setRadarChart(this.getDataSource());
                        }
                    },
                    myTool15: {
                        show: this.props.keywords?true:false,
                        title: '平均分',
                        icon: 'image://../images/avg.svg',
                        onclick: () => {
                            this.setState({
                                mark: !this.state.mark,
                                v: this.props.keywords?this.props.keywords.v:Date.now()
                            })
                            this.initCharts(this.getDataSource());
                        }
                    },
                }
            },
            calculable : true,
            xAxis : [
                {
                    type : 'category',
                    axisLabel: axisLabel ? axisLabel : {
                        rotate: this.state.axisStyle ? 50 : 0, 
                        interval: 0,
                        // interval: 1,
                        formatter: function(value){
                            var ret = "";//拼接加\n返回的类目项
                            //每项显示文字个数
                            var maxLength = axisStyle?15:6;
                            if(!axisStyle && dataLength >= 35) {
                                maxLength = 1;
                                value  = value.length >= 10 ? (value.substring(0, 10) + "...") : value
                            }
                            if(!axisStyle && dataLength >= 20) {
                                maxLength = 2;
                                value  = value.length >= 25 ? (value.substring(0, 25) + "...") : value
                            } else if(!axisStyle && dataLength >= 15) {
                                maxLength = 4;
                                value  = value.length >= 50 ? (value.substring(0, 50) + "...") : value
                            } else if(!axisStyle && dataLength >= 10) {
                                maxLength = 6;
                                value  = value.length >= 80 ? (value.substring(0, 50) + "...") : value
                            }
                            var valLength = value.length;//X轴类目项的文字个数
                            var rowN = Math.ceil(valLength / maxLength);
                            //类目项需要换行的行数
                            if (rowN > 1) {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = "";//每次截取的字符串
                                    var start = i * maxLength;//开始截取的位置
                                    var end = start + maxLength;//结束截取的位置
                                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp; //凭借最终的字符串
                                }
                                return ret;
                            }else {
                                return value;
                            }

                        },
                        textStyle:{
                            color:"#000000",
                            fontSize: 15,
                            // fontWeight: "bolder",
                        }
                    },
                    // data : ['周一','周二','周三','周四','周五','周六','周日']
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    // max: this.props.max ? this.props.max : this.state.max,
                    // min: this.props.min ? this.props.min : this.state.min,
                    // max: this.state.max ? this.state.max : max.toFixed(2),
                    // min: this.state.min ? this.state.min : min.toFixed(2),
                    max: this.getMax(max.toFixed(2)),
                    min: this.getMin(min.toFixed(2)),
                    axisLabel : {
                        formatter: (this.props.yAxis && this.props.yAxis.formatter) ? this.props.yAxis.formatter : '{value}'
                    }
                }
            ],
            series : [
                {
                    name:'评价数据',
                    type: 'line',
                    // type: 'line',
                    data:[11, 11, 15, 13, 12, 13, 10],
                    markLine : this.state.mark ? {} : {
                        data : [
                            {type : 'average', name: '平均值'}
                        ]
                    }
                }
            ]
        };
        let series = Array.from(new Set((dataSource || []).map(item => item.series)))
        let optionSeries = []
        for(let val of series.values()) {
            const names = dataSource.filter(item => item.series === val).map(item => item.name);

            let datas = []
            Array.from(new Set(names)).forEach(n => {
                const data = dataSource.filter(d => d.series === val).find(d => d.name === n);
                datas.push(data.value)
            })
            optionSeries.push({
                name: val,
                type: 'line',
                data: datas,
                markLine : this.state.mark ? {} :{
                    data : [
                        {type : 'average', name: '平均值'}
                    ]
                }
            })
        }
        option.series = optionSeries;
        var category = (dataSource || []).map(item => {
            return item.name;
        });


        option.xAxis[0].data = Array.from(new Set(category));
        // option.series[0].data = values;
        if(series.length > 1) {
            option.legend = {
                // data: series,
                // orient : 'vertical',
                // x : 'left',
                // y : 'bottom',
                data: series,
                top: 40,
                orient : 'vertical',
                x : 'right',
                y : 'top',
            }
        }
        this.chart.setOption(option, true);
    }

    setBarChart(dataSource) {
        if(dataSource.length === 0) {
            return
        }
        this.initChartsType = 'bar'
        const dataLength = Array.from(new Set(dataSource.map(d => d.category))).length
        const axisStyle = this.state.axisStyle 
        dataSource  = dataSource.map(item => {
            return {
                name: item.category,
                count: +item.value,
                value: item.value,
                series: item.series || '数据',
                percentage: item.percentage
            }
        });
        const values = (dataSource || []).map(item => +item.value);
        // 求最大值和最小值
        const valuesMax = values.reduce((a, b) => a > b ? a : b );
        const valuesMin = values.reduce((a, b) => a < b ? a : b);
        // 偏移量
        const d = (valuesMax - valuesMin) * 0.1;
        const max = valuesMax + d;
        const min = (valuesMin - d) <= 0 ? 0 : (valuesMin - d);

        let axisLabel = this.props.axisLabel;
        let option = {
            title : this.props.title ? this.props.title : {
                text: `数据分析`,
                subtext: ``,
                x: 'center'
            },
            tooltip : {
                trigger: 'axis'
            },
            grid: {
                left: '3%',
                right: '10%',
                bottom: '3%',
                containLabel: true
            },
            toolbox: {
                show : true,
                feature : {
                    markUndo : {show: true},
                    markClear : {show: true},
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    saveAsImage : {show: true},
                    myTool26: {
                        show: true,
                        title: '数据导出',
                        icon: 'image://../images/excel.svg',
                        onclick: () => {
                            const exportConfig = this.props.exportConfig;
                            if (exportConfig) {
                                let data = exportConfig.data;
                                const dataCb = exportConfig.dataCb;
                                if (dataCb) {
                                    data = dataCb(this.getDataSource());
                                }
                                const worksheet = XLSX.utils.json_to_sheet(data);
                                const workbook = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1'); 
                                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }); 
                                const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                                FileSaver.saveAs(excelBlob, `${exportConfig.title || '数据导出'}.xlsx`);
                            } else {
                                message.warn('暂不支持');
                            }
                        }
                    },
                    myTool27: {
                        show: true,
                        title: '数据升序',
                        icon: 'image://../images/asc.svg',
                        // icon: 'image://' + bar_icon,
                        onclick: () => {
                            const d = this.getDataSource().map(e => e);
                            d.sort((e1, e2) => {
                                if (e1.value === null && e2.value === undefined) {
                                    return 0;
                                }
                                if (e1.value === null || e2.value === undefined) {
                                    return -1;
                                }
                                return e1.value - e2.value;
                            })
                            this.setBarChart(d);
                        }
                    },
                    myTool28: {
                        show: true,
                        title: '数据降序',
                        icon: 'image://../images/desc.svg',
                        onclick: () => {
                            const d = this.getDataSource().map(e => e);
                            d.sort((e1, e2) => {
                                if (e1.value === null && e2.value === undefined) {
                                    return 0;
                                }
                                if (e1.value === null || e2.value === undefined) {
                                    return -1;
                                }
                                return e2.value - e1.value;
                            })
                            this.setBarChart(d);
                        }
                    },
                    myTool21: {
                        show: true,
                        title: '折线图',
                        icon: 'image://../images/line.svg',
                        // icon: 'image://' + line_icon,
                        onclick: () => {
                            this.setLineChart(this.getDataSource());
                        }
                    },
                    myTool22: {
                        show: true,
                        title: '柱状线',
                        icon: 'image://../images/s-bar.svg',
                        // icon: 'image://' + s_bar_icon,
                        onclick: () => {
                            this.setBarChart(this.getDataSource());
                        }
                    },
                    myTool23: {
                        show: true,
                        title: '饼图',
                        icon: 'image://../images/pie.svg',
                        // icon: 'image://' + pie_icon,
                        onclick: () => {
                            this.setPieChart(this.getDataSource());
                        }
                    },
                    myTool24: {
                        show: true,
                        title: '雷达图',
                        icon: 'image://../images/radar.svg',
                        // icon: 'image://' + radar_icon,
                        onclick: () => {
                            this.setRadarChart(this.getDataSource());
                        }
                    },
                    myTool25: {
                        show: this.props.keywords?true:false,
                        title: '平均分',
                        icon: 'image://../images/avg.svg',
                        onclick: () => {
                            this.setState({
                                mark: !this.state.mark,
                                v: this.props.keywords?this.props.keywords.v:Date.now()
                            })
                            this.initCharts(this.getDataSource());
                        }
                    },
                }
            },
            calculable : true,
            xAxis : [
                {
                    type : 'category',
                    axisLabel: axisLabel ? axisLabel : {
                        // interval: 'auto',
                        rotate: this.state.axisStyle ? 50 : 0, 
                        interval: 0,
                        formatter:function(value){

                            var ret = "";//拼接加\n返回的类目项
                            var maxLength = axisStyle?15:6;//每项显示文字个数
                            if(!axisStyle && dataLength >= 35) {
                                maxLength = 1;
                                value  = value.length >= 10 ? (value.substring(0, 10) + "...") : value
                            }
                            if(!axisStyle && dataLength >= 20) {
                                maxLength = 2;
                                value  = value.length >= 25 ? (value.substring(0, 25) + "...") : value
                            } else if(!axisStyle && dataLength >= 15) {
                                maxLength = 4;
                                value  = value.length >= 50 ? (value.substring(0, 50) + "...") : value
                            } else if(!axisStyle && dataLength >= 10) {
                                maxLength = 6;
                                value  = value.length >= 80 ? (value.substring(0, 50) + "...") : value
                            }
                            var valLength = value.length;//X轴类目项的文字个数
                            var rowN = Math.ceil(valLength / maxLength);
                            //类目项需要换行的行数
                            if (rowN > 1) {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = "";//每次截取的字符串
                                    var start = i * maxLength;//开始截取的位置
                                    var end = start + maxLength;//结束截取的位置
                                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp; //凭借最终的字符串
                                }
                                return ret;
                            }else {
                                return value;
                            }

                        },
                        textStyle:{
                            color:"#000000",
                            fontSize: 15,
                            // fontWeight: "bold",
                        }
                    },
                    // data : ['周一','周二','周三','周四','周五','周六','周日']
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    // max: this.props.max ? this.props.max : this.state.max,
                    // min: this.props.min ? this.props.min : this.state.min,
                    // max: this.state.max ? this.state.max : max.toFixed(2),
                    // min: this.state.min ? this.state.min : min.toFixed(2),
                    max: this.getMax(max.toFixed(2)),
                    min: this.getMin(min.toFixed(2)),
                    axisLabel : {
                        formatter: (this.props.yAxis && this.props.yAxis.formatter) ? this.props.yAxis.formatter : '{value}'
                    }
                }
            ],
            series : [
                {
                    name:'评价数据',
                    type: 'bar',
                    // type: 'line',
                    data:[11, 11, 15, 13, 12, 13, 10],
                    markLine : this.state.mark ? {} :{
                        data : [
                            {type : 'average', name: '平均值'}
                        ]
                    }
                }
            ]
        };
        let series = Array.from(new Set((dataSource || []).map(item => item.series)))
        let optionSeries = []
        for(let val of series.values()) {
            
            const names = dataSource.filter(item => item.series === val).map(item => item.name);
            let datas = []
            Array.from(new Set(names)).forEach(n => {
                const data = dataSource.filter(d => d.series === val).find(d => d.name === n);
                datas.push(data.value)
            })
            optionSeries.push({
                name: val,
                type: 'bar',
                data: datas,
                markLine : this.state.mark ? {} :{
                    data : [
                        {type : 'average', name: '平均值'}
                    ]
                }
            })
        }
        option.series = optionSeries;
        var category = (dataSource || []).map(item => {
            return item.name;
        });

        option.xAxis[0].data = Array.from(new Set(category));
        if(series.length > 1) {
            option.legend = {
                data: series,
                top: 40,
                orient : 'vertical',
                x : 'right',
                y : 'top',
            }
        }
        this.chart.setOption(option, true);
    }

    setPieChart(dataSource) {
        this.initChartsType = 'pie'
        const categorySet = new Set(dataSource.map(d => d.category));
        let categoryNames = Array.from(categorySet);

        const seriesSet = new Set(dataSource.map(d => d.series))
        let seriesNames = Array.from(seriesSet);
        
        if (seriesNames.length === 1) {
            dataSource  = dataSource.map(item => {
                return {
                    name: item.category,
                    count: +item.value,
                    value: item.value,
                    percentage: item.percentage,
                    series: item.series
                }
            });
        } else {
            dataSource  = dataSource.map(item => {
                return {
                    name: item.series,
                    count: +item.value,
                    value: item.value,
                    percentage: item.percentage,
                    category: item.category
                }
            });
        }

        let legendData = Array.from(new Set((dataSource || []).map(item => item.name)));
        
        let option = {
            title : this.props.title ? this.props.title : {
                text: `数据分析`,
                subtext: ``,
                x: 'center'
            },
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                type: 'scroll',
                orient: 'vertical',
                right: 10,
                top: 40,
                bottom: 20,
                data: legendData,
                formatter: function(val) {
                    if(categoryNames.length === 3) {
                        return val.length <= 7 ? val : (val.substring(0, 7) + "...");
                    } else if(categoryNames.length === 2) {
                        return val.length <= 10 ? val : (val.substring(0, 10) + "...");
                    }
                    return val.length <= 15 ? val : (val.substring(0, 15) + "...");
                }
            },
            toolbox: {
                show: true,
                feature : {
                    markUndo : {show: true},
                    markClear : {show: true},
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    saveAsImage : {show: true},
                    myTool31: {
                        show: true,
                        title: '折线图',
                        icon: 'image://../images/line.svg',
                        // icon: 'image://' + line_icon,
                        onclick: () => {
                            this.setLineChart(this.getDataSource());
                        }
                    },
                    myTool32: {
                        show: true,
                        title: '柱状线',
                        icon: 'image://../images/bar.svg',
                        // icon: 'image://' + bar_icon,
                        onclick: () => {
                            this.setBarChart(this.getDataSource());
                        }
                    },
                    myTool33: {
                        show: true,
                        title: '饼图',
                        icon: 'image://../images/s-pie.svg',
                        // icon: 'image://' + s_pie_icon,
                        onclick: () => {
                            this.setPieChart(this.getDataSource());
                        }
                    },
                    myTool34: {
                        show: true,
                        title: '雷达图',
                        icon: 'image://../images/radar.svg',
                        // icon: 'image://' + radar_icon,
                        onclick: () => {
                            this.setRadarChart(this.getDataSource());
                        }
                    },
                    myTool35: {
                        show: this.props.keywords?true:false,
                        title: '平均分',
                        icon: 'image://../images/avg.svg',
                        onclick: () => {
                            this.setState({
                                mark: !this.state.mark,
                                v: this.props.keywords?this.props.keywords.v:Date.now()
                            })
                            this.initCharts(this.getDataSource());
                        }
                    },
                }
            },
            series: [
                {
                    name: '数据分析',
                    type: 'pie',
                    radius: '50%',
                    center: ['40%', '50%'],
                    data: [],
                    animation: false,
                    label: {
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5,
                        rotate: this.props.rotate ?  this.props.rotate : 0,
                        formatter: function(data) {
                            let value = data.name;
                            value = value.length >= 30 ? (value.substring(0, 30) + "...") : value
                            return value;
                        }
                    },
                }
            ]
        }
    
        let distance = 0
        let start = 50
        let radius = '50%'
        let centerArray = []
        if(categoryNames.length === 1) {
            centerArray = [['50%', '50%']]
        } else if(categoryNames.length === 2) {
            radius = '40%'
            centerArray = [['20%', '50%'], ['65%', '50%']]
        } else if(categoryNames.length === 3 || categoryNames.length === 4) {
            radius = '30%'
            centerArray = [['20%', '35%'], ['65%', '35%'], ['20%', '80%'], ['65%', '80%']]
        } else if (categoryNames.length > 4) {
            categoryNames = categoryNames.slice(0, 4);
            radius = '30%'
            centerArray = [['20%', '35%'], ['65%', '35%'], ['20%', '80%'], ['65%', '80%']]
        }
        if (seriesNames.length === 1) {
            let seriesArray = []
            for(let i = 0; i < seriesNames.length; i++) {
                let series = this.formatSeries(seriesNames[i], dataSource, ['50%', '50%'], '50%');
                seriesArray.push(series);
            }
            option.series = seriesArray;
        } else {
            let categoryArray = []
            for(let i = 0; i < categoryNames.length; i++) {
                let center = centerArray[i]
                let category = this.formatCategory(categoryNames[i], dataSource, center, radius)
                categoryArray.push(category)
            }
            option.series = categoryArray;
        }
        
        this.chart.setOption(option, true);
    }

    formatSeries(s, dataSource, center, radius) {
        let series = {
            name: s ? s : '数据分析',
            type: 'pie',
            radius: radius,
            // center: [`${center}%`, '50%'],
            center: center,
            data: [],
            animation: false,
            label: {
                position: 'outer',
                alignTo: 'labelLine',
                bleedMargin: 5,
                textStyle:{
                    fontSize: 15,
                    fontWeight: "bolder",
                },
                rotate: this.props.rotate ?  this.props.rotate : 0,
                formatter: function(data) {
                    let value = data.name;
                    value = value.length >= 15 ? (value.substring(0, 15) + "...") : value
                    return value;
                }
            }
        }
        series.data = dataSource.filter(d => d.series === s)
        return series
    }

    formatCategory(s, dataSource, center, radius) {
        let category = {
            name: s ? s : '数据分析',
            type: 'pie',
            radius: radius,
            // center: [`${center}%`, '50%'],
            center: center,
            data: [],
            animation: false,
            label: {
                position: 'outer',
                alignTo: 'labelLine',
                bleedMargin: 5,
                rotate: this.props.rotate ?  this.props.rotate : 0,
                formatter: function(data) {
                    if (!data || !data.name) {
                        return;
                    }
                    let value = data.name;
                    value = value.length >= 15 ? (value.substring(0, 15) + "...") : value
                    return value;
                }
            }
        }
        category.data = dataSource.filter(d => d.category === s);
        return category
    }


    setRadarChart(dataSource) {
        // dataSource.forEach(item => {
        //     item.series = item.series ? item.series : '雷达图';
        // })
        this.initChartsType = 'radar'
        const seriesSet = new Set(dataSource.map(d => d.series))
        let seriesNames = Array.from(seriesSet);
        dataSource = dataSource.map(item => {
            return {
                ...item,
                series: item.series ? item.series : '雷达图'
            }
        })
        let option = {
            title : this.props.title ? this.props.title : {
                text: `数据分析`,
                subtext: ``,
                x: 'center'
            },
            tooltip : {
                confine: true
            },
            radar: {
                name: {
                    textStyle: {
                        color: '#000',
                        padding: [15, 20],
                        fontSize: 15
                    },
                    formatter: function(value) {
                        return value = value.length >= 50 ? (value.substring(0, 50) + "...") : value
                    }
                },
                center: ['50%', '52%'],
                radius: '60%',
                indicator: [],
            },
            legend: {
                // orient : 'vertical',
                // x : 'left',
                // y : 'bottom',
                orient : 'vertical',
                top: 40,
                x : 'right',
                y : 'top',
                data:[]
            },
            toolbox: {
                show : true,
                feature : {
                    markUndo : {show: true},
                    markClear : {show: true},
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    saveAsImage : {show: true},
                    myTool41: {
                        show: true,
                        title: '折线图',
                        icon: 'image://../images/line.svg',
                        // icon: 'image://' + line_icon,
                        onclick: () => {
                            this.setLineChart(this.getDataSource());
                        }
                    },
                    myTool42: {
                        show: true,
                        title: '柱状线',
                        icon: 'image://../images/bar.svg',
                        // icon: 'image://' + bar_icon,
                        onclick: () => {
                            this.setBarChart(this.getDataSource());
                        }
                    },
                    myTool43: {
                        show: true,
                        title: '饼图',
                        icon: 'image://../images/pie.svg',
                        // icon: 'image://' + pie_icon,
                        onclick: () => {
                            this.setPieChart(this.getDataSource());
                        }
                    },
                    myTool44: {
                        show: true,
                        title: '雷达图',
                        icon: 'image://../images/s-radar.svg',
                        // icon: 'image://' + s_radar_icon,
                        onclick: () => {
                            this.setRadarChart(this.getDataSource());
                        }
                    },
                    myTool45: {
                        show: this.props.keywords?true:false,
                        title: '平均分',
                        icon: 'image://../images/avg.svg',
                        onclick: () => {
                            this.setState({
                                mark: !this.state.mark,
                                v: this.props.keywords?this.props.keywords.v:Date.now()
                            })
                            this.initCharts(this.getDataSource());
                        }
                    },
                }
            },
            series: [{
                name: '数据分析',
                type: 'radar',
                // areaStyle: {normal: {}},
                data : [
                    {
                        value : [],
                        name : '指标分析'
                    }
                ]
            }]
        };
        if(dataSource && dataSource.length) {
            const map = {};
            option.radar.indicator = [];
            const values = (dataSource || []).map(item => +item.value);
            // 求最大值和最小值
            const valuesMax = values.reduce((a, b) => a > b ? a : b );
            const valuesMin = values.reduce((a, b) => a < b ? a : b);
            // 偏移量
            const d = (valuesMax - valuesMin) * 0.1;

            (dataSource || []).forEach(item => {
                if(!map[item.category]) {
                    map[item.category] = 1;
                    option.radar.indicator.push({
                        name: item.category,
                        max: this.state.max ? this.state.max : valuesMax + d,
                        min: this.state.min ? this.state.min : valuesMin - d,
                    });
                }
            });

            const groups = {};

            (dataSource || []).forEach(item => {
                if(!groups[item.series]) {
                    groups[item.series] = [];
                }

                groups[item.series].push(+(item.value) );
            });
            let legend = Object.keys(groups);
            if(legend.length >= 1 && legend[0] && legend[0] != 'null') {
                option.legend.data = Object.keys(groups);
            }

            option.series[0].data = Object.keys(groups).map(key => {
                return {
                    value : groups[key],
                    name : key
                }
            });
            option.radar.shape = 'polygon',
                this.chart.setOption(option, true);
        }
    }

    render() {
        const height = this.props.height ? this.props.height : 350;
        const style = {
            height
        }
        return (
            <div>
                { this.props.service ?
                    <Spin tip="数据加载中..." spinning={this.state.loading}>
                        <div className="root-modal-chart" style={style} >
                            <div className="root-chart" ref="chart"></div>
                        </div>
                    </Spin> 
                    :  
                    <div className="root-modal-chart" style={style} >
                        <div className="root-chart" ref="chart"></div>
                    </div> 
                }
            </div>
        )
    }
}
